@if (!isLoading) {
  <app-filter
    id="filterMenu"
    [isOpen]="filterMenuOpen"
    [filters]="filters"
    (filterMenuOpenChange)="filterMenuOpen = $event"
    (filterChange)="onFiltersChange($event)"></app-filter>
}

<div
  class="file-manager-container"
  [ngStyle]="
    useCategoryColors
      ? {
          '--general-80': seminarCategory?.color80 ?? getDefaultColor(80),
          '--general-0': seminarCategory?.color0 ?? getDefaultColor(0),
        }
      : {
          '--general-80': '#d2e0de',
          '--general-0': '#0e332e',
        }
  ">
  <div class="flex-c align-start gap-12 align-self-stretch">
    <div class="header">
      <div class="flex-r gap-8 align-center header-title">
        <div class="icon-28">
          @if (isLoading) {
            <i class="fa-regular fa-spinner-third fa-spin"></i>
          } @else {
            <i class="fa-regular fa-paperclip-vertical"></i>
          }
        </div>
        <span class="attachment-count">
          @if (isLoading) {
            Lade Anhänge...
          } @else {
            {{ uploadedFilesCount }}
            {{ uploadedFilesCount === 1 ? 'Anhang' : 'Anhänge' }}
          }
        </span>
      </div>

      <div class="header-actions">
        <div class="table-search">
          <input
            type="text"
            name="table-search"
            placeholder="Hier suchen..."
            (input)="applySearch($event)" />
        </div>
        <button
          type="button"
          class="inwi-icon-text-button-medium-outline"
          [disabled]="isLoading"
          (click)="onOpenFilterMenu()">
          <div class="button-content">
            <div id="filterIcon" class="button-icon">
              <i class="fa-regular fa-filter"></i>
            </div>
            <div class="button-text">Filter</div>
          </div>
        </button>
        @if (allowUpload) {
          <input
            type="file"
            #fileInput
            [accept]="getAcceptedFileTypes()"
            (change)="onFileSelected($event)"
            style="display: none" />
          <div class="flex">
            <button
              type="button"
              class="inwi-icon-text-button-medium-outline"
              [disabled]="uploadProgress !== null"
              (click)="uploadMenu.toggle($event)">
              <div class="button-content">
                <div class="button-text">Hochladen</div>
                <i class="fa-regular fa-angle-down button-icon"></i>
              </div>
            </button>
            <p-menu #uploadMenu [model]="uploadMenuItems" [popup]="true">
              <ng-template pTemplate="item" let-item>
                <a
                  pRipple
                  class="flex align-items-center p-menu-item-link icon-24">
                  <i [class]="item.icon"></i>
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </ng-template>
            </p-menu>
          </div>
        }
        @if (seminarId && documentFiles.length > 1) {
          <button
            type="button"
            class="inwi-icon-text-button-medium-outline"
            [disabled]="isSavingOrder"
            (click)="toggleReorderMode()">
            <div class="button-content">
              <div class="button-icon">
                <i
                  class="fa-regular"
                  [class]="
                    reorderMode
                      ? isSavingOrder
                        ? 'fa-spinner-third fa-spin'
                        : 'fa-floppy-disk'
                      : 'fa-arrows-up-down-left-right'
                  "></i>
              </div>
              <div class="button-text">
                {{
                  reorderMode
                    ? isSavingOrder
                      ? 'Speichere...'
                      : 'Reihenfolge speichern'
                    : 'Reihenfolge ändern'
                }}
              </div>
            </div>
          </button>
        }
      </div>
    </div>

    @if (uploadProgress !== null) {
      <div class="upload-progress-container">
        <p-progressBar
          [value]="uploadProgress"
          [showValue]="true"></p-progressBar>
      </div>
    }

    <div class="file-container">
      @if (isFileAndLinkEmpty) {
        <div class="empty-state">
          <div class="icon-72">
            <i class="fa-regular fa-paperclip-vertical"></i>
          </div>
          <span class="font-regular-body-medium">
            @if (hasActiveFilters) {
              Es gibt keine Anhänge, die mit deinen Suchkriterien
              übereinstimmen.
            } @else {
              Du hast derzeit keine Anhänge verfügbar.
            }
          </span>
        </div>
      } @else {
        <p-panel
          [toggleable]="true"
          [toggler]="'header'"
          [collapsed]="panelCollapsed"
          [iconPos]="'start'">
          <ng-template #headericons let-collapsed>
            <i
              class="fa-regular"
              [class.fa-angle-down]="collapsed"
              [class.fa-angle-up]="!collapsed"></i>
          </ng-template>
          <ng-template pTemplate="header">
            <span class="title">Dokumente</span>
          </ng-template>
          @if (reorderMode) {
            <p-orderList
              [value]="reorderFiles"
              [dragdrop]="true"
              (onReorder)="onReorderDocuments()">
              <ng-template let-file pTemplate="item">
                <div class="file-row">
                  <div class="position-circle">{{ file.position }}</div>
                  <span class="title">{{ file.name }}</span>
                </div>
              </ng-template>
            </p-orderList>
          } @else {
            @if (documentFiles.length === 0) {
              <span class="font-regular-body-medium">
                @if (isLoading) {
                  Lade Dokumente...
                } @else {
                  Keine Dokumente vorhanden.
                }
              </span>
            } @else if (listView) {
              <!-- NEW LIST VIEW TABLE -->
              <table class="file-list-view">
                <tbody>
                  @for (file of documentFiles; track file.id) {
                    <tr
                      class="clickable-row"
                      tabindex="0"
                      (click)="onOpenFile(file)"
                      (keydown.enter)="onOpenFile(file)"
                      (keydown.space)="
                        onOpenFile(file); $event.preventDefault()
                      ">
                      <td class="icon-col">
                        <i
                          class="fa-regular {{
                            getIconForFile(file)
                          }} fa-lg"></i>
                      </td>
                      <td
                        class="title-col"
                        [pTooltip]="file.name"
                        tooltipPosition="top">
                        <i
                          class="fa-regular {{
                            getIconForFile(file)
                          }} fa-lg mobile-icon"></i>
                        <span>
                          {{ file.name }}
                        </span>
                      </td>
                      <td class="date-col">
                        {{
                          file.createdAt
                            ? (file.createdAt | date: 'dd.MM.yyyy')
                            : '-'
                        }}
                      </td>
                      @if (adminAreaActive && (allowRename || allowDelete)) {
                        <td
                          class="action-col"
                          (click)="$event.stopPropagation()">
                          <div class="action-buttons">
                            @if (allowRename && !allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="renameFile(file)"
                                pTooltip="Umbenennen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="openEditFileDialog(file)"
                                pTooltip="Bearbeiten"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="deleteFile(file)"
                                pTooltip="Löschen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <!-- existing card view -->
              <div class="file-card-container">
                @for (documentFile of documentFiles; track documentFile.id) {
                  <app-file-card
                    [file]="documentFile"
                    (fileDeleted)="onFileDeleted($event)"
                    [allowDelete]="allowDelete"></app-file-card>
                }
              </div>
            }
          }
        </p-panel>
        <p-panel
          [toggleable]="true"
          [toggler]="'header'"
          [collapsed]="panelCollapsed"
          [iconPos]="'start'">
          <ng-template #headericons let-collapsed>
            <i
              class="fa-regular"
              [class.fa-angle-down]="collapsed"
              [class.fa-angle-up]="!collapsed"></i>
          </ng-template>
          <ng-template pTemplate="header">
            <span class="title">Bilder</span>
          </ng-template>
          @if (reorderMode) {
            <p-orderList
              [value]="reorderImageFiles"
              [dragdrop]="true"
              (onReorder)="onReorderImages()">
              <ng-template let-file pTemplate="item">
                <div class="image-reorder-item">
                  <div
                    class="thumb"
                    [style.background-image]="
                      imagePreviewMap[file.id]
                        ? 'url(' + imagePreviewMap[file.id] + ')'
                        : 'none'
                    ">
                    @if (!imagePreviewMap[file.id]) {
                      <i class="fa-regular fa-image"></i>
                    }
                  </div>
                  <div class="meta">
                    <div class="position-circle">{{ file.position }}</div>
                    <div
                      class="name"
                      [pTooltip]="file.name"
                      tooltipPosition="top">
                      {{ file.name }}
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-orderList>
          } @else {
            @if (imageFiles.length === 0) {
              <span>
                @if (isLoading) {
                  Lade Bilder...
                } @else {
                  Keine Bilder vorhanden.
                }
              </span>
            } @else if (listView) {
              <table class="file-list-view">
                <tbody>
                  @for (file of imageFiles; track file.id) {
                    <tr
                      class="clickable-row"
                      tabindex="0"
                      (click)="onOpenFile(file)"
                      (keydown.enter)="onOpenFile(file)"
                      (keydown.space)="
                        onOpenFile(file); $event.preventDefault()
                      ">
                      <td class="thumb-col">
                        <div
                          class="thumb-cell"
                          [style.background-image]="
                            imagePreviewMap[file.id]
                              ? 'url(' + imagePreviewMap[file.id] + ')'
                              : 'none'
                          ">
                          @if (!imagePreviewMap[file.id]) {
                            <i class="fa-regular fa-image"></i>
                          }
                        </div>
                      </td>
                      <td
                        class="title-col"
                        [pTooltip]="file.name"
                        tooltipPosition="top">
                        {{ file.name }}
                      </td>
                      <td class="date-col">
                        {{
                          file.createdAt
                            ? (file.createdAt | date: 'dd.MM.yyyy')
                            : '-'
                        }}
                      </td>
                      @if (adminAreaActive && (allowRename || allowDelete)) {
                        <td
                          class="action-col"
                          (click)="$event.stopPropagation()">
                          <div class="action-buttons">
                            @if (allowRename && !allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="renameFile(file)"
                                pTooltip="Umbenennen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="openEditFileDialog(file)"
                                pTooltip="Bearbeiten"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="deleteFile(file)"
                                pTooltip="Löschen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="file-card-container">
                @for (imageFile of imageFiles; track imageFile.id) {
                  <app-file-card
                    [file]="imageFile"
                    (fileDeleted)="onFileDeleted($event)"
                    [allowDelete]="allowDelete"></app-file-card>
                }
              </div>
            }
          }
        </p-panel>
        <p-panel
          [toggleable]="true"
          [toggler]="'header'"
          [collapsed]="panelCollapsed"
          [iconPos]="'start'">
          <ng-template #headericons let-collapsed>
            <i
              class="fa-regular"
              [class.fa-angle-down]="collapsed"
              [class.fa-angle-up]="!collapsed"></i>
          </ng-template>
          <ng-template pTemplate="header">
            <span class="title">Links</span>
          </ng-template>
          @if (reorderMode) {
            <p-orderList
              [value]="reorderLinks"
              [dragdrop]="true"
              (onReorder)="onReorderLinks()">
              <ng-template let-link pTemplate="item">
                <div class="file-row">
                  <div class="position-circle">{{ link.position }}</div>
                  <span class="title">{{ link.title }}</span>
                </div>
              </ng-template>
            </p-orderList>
          } @else {
            @if (links.length === 0) {
              <span>
                @if (isLoading) {
                  Lade Links...
                } @else {
                  Keine Links vorhanden.
                }
              </span>
            } @else if (listView) {
              <table class="file-list-view">
                <tbody>
                  @for (link of links; track link.id) {
                    <tr
                      class="clickable-row"
                      tabindex="0"
                      (click)="onOpenLink(link)"
                      (keydown.enter)="onOpenLink(link)"
                      (keydown.space)="
                        onOpenLink(link); $event.preventDefault()
                      ">
                      <td class="icon-col">
                        <i class="fa-regular {{ getIconForLink() }} fa-lg"></i>
                      </td>
                      <td
                        class="title-col"
                        [pTooltip]="link.title"
                        tooltipPosition="top">
                        <i
                          class="fa-regular {{
                            getIconForLink()
                          }} fa-lg mobile-icon"></i>
                        <span class="link-text">{{ link.title }}</span>
                      </td>
                      <td class="date-col">
                        {{
                          link.createdAt
                            ? (link.createdAt | date: 'dd.MM.yyyy')
                            : '-'
                        }}
                      </td>
                      @if (adminAreaActive && (allowRename || allowDelete)) {
                        <td
                          class="action-col"
                          (click)="$event.stopPropagation()">
                          <div class="action-buttons">
                            @if (allowRename && !allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="renameLink(link)"
                                pTooltip="Umbenennen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="openEditLinkDialog(link)"
                                pTooltip="Bearbeiten"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                            }
                            @if (allowDelete) {
                              <button
                                type="button"
                                class="inwi-icon-button-small-secondary"
                                (click)="deleteLink(link)"
                                pTooltip="Löschen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="file-card-container">
                @for (link of links; track link.id) {
                  <app-link-card
                    [link]="link"
                    (linkDeleted)="onLinkDeleted($event)"
                    [allowDelete]="allowDelete"></app-link-card>
                }
              </div>
            }
          }
        </p-panel>
      }
    </div>
  </div>
</div>
